import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import PersonIcon from '@mui/icons-material/Person';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import CodeIcon from '@mui/icons-material/Code';
import HomeIcon from '@mui/icons-material/Home';
import DateRangeIcon from '@mui/icons-material/DateRange';
import PhoneIcon from '@mui/icons-material/Phone';

function Plus_details_dialog({openDetails,handleCloseDetails,chosenSubmission,emailService}){


    return (
        <Dialog fullWidth={true} maxWidth={'md'} open={openDetails} onClose={handleCloseDetails} aria-labelledby="form-dialog-title" >
          <DialogContent>
            <div className="plus_details_dialog_container">
            <TextField variant='standard'  label="Maison mère" value={chosenSubmission.parentCompany} className="header_form"
                  InputProps={{ startAdornment: ( <InputAdornment position="start"> <HomeIcon className="my_icon" /> </InputAdornment> ), }}
                  disabled
              />
              <TextField variant='standard'  label="Adresse" value={chosenSubmission.address+'-'+chosenSubmission.city+'-'+chosenSubmission.country} className="header_form"
                  InputProps={{ startAdornment: ( <InputAdornment position="start"> <PersonPinCircleIcon className="my_icon" /> </InputAdornment> ), }}
                  disabled
              />
              <TextField variant='standard'  label="cnss" type="number"value={chosenSubmission.cnss} className="header_form"
                  InputProps={{ startAdornment: ( <InputAdornment position="start"> <CodeIcon className="my_icon" /> </InputAdornment> ), }}
                  disabled
              />
              <TextField variant='standard'  label="téléphone " value={chosenSubmission.phoneNumber} className="header_form"
                  InputProps={{ startAdornment: ( <InputAdornment position="start"> <PhoneIcon className="my_icon" /> </InputAdornment> ), }}
                  disabled
              />
              <TextField variant='standard'  label="Identifiant fiscal" value={chosenSubmission.fiscalIdentifier} className="header_form"
                  InputProps={{ startAdornment: ( <InputAdornment position="start"> <CodeIcon className="my_icon" /> </InputAdornment> ), }}
                  disabled
              />
              <TextField variant='standard'  label="Num de patente"  value={chosenSubmission.licenseNumber} className="header_form"
                  InputProps={{ startAdornment: ( <InputAdornment position="start"> <CodeIcon className="my_icon" /> </InputAdornment> ), }}
                  disabled
              />
              <TextField variant='standard'  label="Num ICE " value={chosenSubmission.iceNumbner} className="header_form"
                  InputProps={{ startAdornment: ( <InputAdornment position="start"> <CodeIcon className="my_icon" /> </InputAdornment> ), }}
                  disabled
              />
              {/* <TextField variant='standard'  label="Année de constitution"  value={chosenSubmission.anneeConstitution} className="header_form"
                  InputProps={{ startAdornment: ( <InputAdornment position="start"> <DateRangeIcon className="my_icon" /> </InputAdornment> ), }}
                  disabled
              /> */}
              
            </div>
          
          </DialogContent>
        </Dialog>  
    );
}

export default Plus_details_dialog;
